export const SELECT_SENTENCE = 'SELECT_SENTENCE';

export const selectSentenceDetails = sentence => ({
  type: SELECT_SENTENCE,
  data: sentence,
});
